/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Holiday {
    angular.module("meevo.plugins.holiday", []);
}